import { Component, OnInit, NgModule, ViewChild, Output, EventEmitter } from '@angular/core';
import {
  Router,
  // import as RouterEvent to avoid confusion with the DOM Event
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
  ActivatedRoute
} from '@angular/router';
import { PowerUsage, Service } from '../mock-data/mock-data';
import { AccountDeviceModel } from '../models/AccountDevicesModel';
import { LoginService } from '../services/login.service';
import { WaterUsageService } from '../services/water-usage.service';
import { BrowserModule } from '@angular/platform-browser';
import { DxChartModule, DxChartComponent, DxButtonModule, DxDateBoxModule, DxDataGridComponent } from 'devextreme-angular';
import { AccountDetailsService } from '../services/account-details.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AlarmsService } from '../services/alarms-service.service';
import moment from 'moment';
import { } from '@types/googlemaps';
import { CurrentAccount } from '../models/AccountModel';
import { debug } from 'util';
import { AccountDetails } from '../models/AccountDetail';
import { UserInfoModel } from '../models/UserInfoModel';


@Component({
  selector: 'app-usage-container',
  templateUrl: './usage-container.component.html',
  styleUrls: ['./usage-container.component.css'],
  providers: [Service],
})
export class UsageContainerComponent implements OnInit {
  display = 'none';
  acctDetails: AccountDetails;
  customerInfo: UserInfoModel;
  usageDs: PowerUsage[] = [];
  timeRange = '30 days';
  compareTimeRange = 'Previous 30 days';
  successMessage: string;
  errorMessage: string;
  compareSelect = "";
  showSuccessMessage = false;
  showCompare = false;
  contextCompare = false;
  loadDatePicker = false;
  meterId: string;
  twoFactorSource: string;
  discoDate = null;
  dateselcted = null;
  customRangeMsg = "";
  now = Date.now();
  prev30DateMin = moment(this.now).subtract(30, 'days').format('L');
  prev7DateMin = moment(this.now).subtract(7, 'days').format('L');
  prev24DateMin = moment(this.now).subtract(1, 'days').format('LLL');
  tomorrow = moment(this.now).add(1, 'days').toDate();
  minDate = this.prev30DateMin;
  dateType = "date";
  value = null;
  customValueStart = null;
  customValueEnd = null;
  showCustomRangeMsg = true;
  consumptionType = "";
  consumptionTypeDisplay = "";
  loading = true;
  lat = 0;
  lon = 0;
  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;
  @ViewChild(DxChartComponent) chart: DxChartComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
  showCalendar: boolean;
  showTempDisco: boolean;
  showTempDiscoMsg: boolean;
  showTwoFactorInput: boolean;
  showTwoFactorInputTemp: boolean;
  showDiscoSelect: boolean;
  showBudget: boolean;
  showSuccess: boolean;
  showError: boolean;
  currentAccount: CurrentAccount;
  meterID: string;
  customerEmail: string;
  customerSMS: string;
  customerName: string;
  serviceDate: string;
  usageTotal: number;
  mainUsageTotal: number;
  twoFactorInput: string;
  budgetInput: number;
  currentBudget: number;
  alarms: any = {};
  showli_one: boolean;
  showli_two: boolean;
  showli_three: boolean;
  showli_four: boolean;
  showli_five: boolean;
  showCustom: boolean;
  discoSelected: boolean;
  startdatevalue: string;
  enddatevalue: string;
  deviceId: number;
  computedValue: string;
  showTwoFactorSelect: boolean;
  accepted: boolean;
  orgUnitName: string;
  scheduleddate: string;
  scheduled: boolean;
  needCompare: boolean;
  shutOffOptions = [
    { id: 0, name: "" },
    { id: 1, name: "Connect Water Service" },
    { id: 2, name: "Disconnect Water Service" }
  ];
  selectedValue = null;
  times: any[] = [];
  contype: string;
  contypetext: string;
  pendingCommands: any[] = [];
  activeAcctID: any;
  nextBill: number;
  currentBill: number;
  hasBillEstimates: boolean;
  hasBillingRange: boolean;
  billingRange: string;
  items: any[] = [];
  budget: number;
  dataGridColumns = [
    { dataField: 'date', caption: 'Date' },
    { dataField: 'usage', caption: 'Usage' },
    { dataField: 'cost', caption: 'Cost' },
  ];
  downloadGridData() {
    this.dataGrid.instance.exportToExcel(false);
  }

  constructor(
    private service: Service,
    private loginService: LoginService,
    private waterUsageService: WaterUsageService,
    private router: Router,
    private alarmsService: AlarmsService,
    private acctDetailsService: AccountDetailsService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    //router.events.subscribe((event: RouterEvent) => {
    //  this.navigationInterceptor(event)
    //})
  }

  onCloseHandled(datetime, type) {
    this.display = 'none';
    if (type === 'disco') {
      this.dateselcted = datetime;
      this.discoSelected = true;
    }
    if (type === 'reco') {
      this.dateselcted = datetime;
      this.discoSelected = true;
    }

  }
  openModel() {
    this.display = 'block';
  }

  dateValueChanged(type, e) {
    const previousValue = e.previousValue;
    const newValue = e.value;
    this.contype = type;
    this.contypetext = this.contype === "disco" ? "Disconnect" : "Connect";

    if (newValue !== undefined && newValue !== null) {
      this.loadMeterDates(false, moment(newValue).format('LL').toString(), this.contype);
      this.openModel();
    } else {
      alert("Date must be selected and cannot be left empty.")
    }
  }

  loadMeterDates(isOpen, date, type) {
    this.acctDetailsService.getMeterDates(this.deviceId.toString(), isOpen, date)
      .subscribe((res) => {
        if (res.success) {
          this.orgUnitName = res.modelRet.orgName;
          this.times = res.modelRet.currentAvailableTimes;
          for (var i = 0; this.times.length >= i; i++) {
            let item = this.times[i];
            item.dateUTC = moment.utc(item.dateUTC).format("LLL");
          }
        }
      });
  }

  fieldsChange(values: any) {
    if (values.currentTarget.checked) {
      this.accepted = true;
    } else {
      this.accepted = false;
    }
  }

  customizeAlarmDateText = (cellInfo: { value: string | number }): string => {
    if (!cellInfo.value) {
      return '';
    }

    // Tarih stringini ISO 8601 formatına çevirme
    let utcDateStr = cellInfo.value.toString();
    if (!utcDateStr.endsWith('Z')) {
      utcDateStr += 'Z'; // UTC olarak belirtmek için 'Z' ekleme
    }

    const date = new Date(utcDateStr);

    if (isNaN(date.getTime())) {
      return '';
    }

    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZoneName: 'short'
    };

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const formattedDate = date.toLocaleString('en-US', { ...options, timeZone: timezone });
    return `${formattedDate} (${timezone})`;
  };


  export() {
    this.chart.instance.refresh();

    setTimeout(() => {
      this.chart.instance.exportTo("UsageChart", "png");
    }, 1000); 
  }

  print() {
    this.chart.instance.print();
  }

  selectChanged(e) {
    let type = e.srcElement.value;
    this.accepted = false;
    this.discoSelected = false;
    this.startdatevalue = null;
    this.discoDate = null;

    if (type === "Disconnect Water Service") {
      this.showSuccessMessage = false;
      this.showTempDisco = false;
      this.showCalendar = true;
    }
    if (type === "Connect Water Service") {
      this.showSuccessMessage = false;
      this.showTempDisco = true;
      this.showCalendar = false;
    }
  }

  configureBudget() {
    this.showBudget = true;
  }
  cancelBudget() {
    this.showBudget = false;
  }

  cancelShutOffSelect() {
    this.showCalendar = false;
    this.showDiscoSelect = false;
    this.showTempDisco = false;
    this.showTwoFactorInput = false;
    this.showTwoFactorInputTemp = false;
  }

  showDisconnectCalendar() {
    this.showCalendar = true;
  }
  cancelDisconnet() {
    this.showDiscoSelect = false;
    this.showCalendar = false;
    this.showTempDisco = false;
  }

  toggleli_one() {
    return this.showli_one = !this.showli_one;
  }
  toggleli_two() {
    return this.showli_two = !this.showli_two;
  }
  toggleli_three() {
    return this.showli_three = !this.showli_three;
  }
  toggleli_four() {
    return this.showli_four = !this.showli_four;
  }
  toggleli_five() {
    return this.showli_five = !this.showli_five;
  }

  customizeTooltip(arg: any) {
    const dataObj = arg.point.data;
    if (arg.seriesName === "Usage") {
      const unit = dataObj.type;
      const computedReading = dataObj.computedReading;
      return {
        text: `Meter Reading: ${computedReading} \nConsumption: ${arg.value} ${unit}`      }
    } else {
      return {
        text: "$" + arg.valueText
      }
    }
  }
  customizeText(arg: any) {
    return arg.value;
  }
  customizeLabel = (arg: any) => {
    return {
      visible: true,
      backgroundColor: "#ff7c7c",
      customizeText: function (e: any) {
        return "$" + e.valueText
      }
    };
  }

  cancelSchedule(commandId) {
    let localTime = moment.utc(new Date()).toDate();
    let localTimeFormatted = moment(localTime).format('LLL');

    let model = {
      commandId: commandId,
      scheduledDate: localTimeFormatted,
    }

    this.acctDetailsService.cancelCommand(model)
      .subscribe((res) => {
        if (res.success) {
          this.showPendingCommands(this.deviceId);
          this.showSuccess = true;
          this.successMessage = "Your request was successfully cancelled";
        } else {
          this.showError = true;
          this.errorMessage = "An error has occurred, contact an administrator if the problem persists";
        }
      });
  }

  sendTempShutOffInfo(currentAccount, startdatevalue) {
    if ((startdatevalue === undefined || startdatevalue === null)) {
      alert("You must select a date to proceed.");
    }
    else {
      this.spinnerService.show();
      if (this.twoFactorSource === "email") {
        this.loginService.sendTwoFactorRequest(this.currentAccount.OrgUnitId, 1, this.customerEmail, this.meterID)
          .subscribe((res) => {
            if (res.success) {
              this.showTwoFactorInputTemp = true;
              this.showTempDisco = false;
              this.startdatevalue = startdatevalue;
            } else {
              this.showError = true;
              this.errorMessage = "An error has occurred, contact an administrator if the problem persists";
            }
          });
      } else {
        this.loginService.sendTwoFactorRequest(this.currentAccount.OrgUnitId, 2, this.customerSMS, this.meterID)
          .subscribe((res) => {
            if (res.success) {
              this.showTwoFactorInputTemp = true;
              this.showTempDisco = false;
              this.startdatevalue = startdatevalue;
            } else {
              this.showError = true;
              this.errorMessage = "An error has occurred, contact an administrator if the problem persists";
            }
          });
      }
    }
  }

  validateBudgetInput(input) {
    if (input === undefined || input === null) {
      alert("Budget amount cannot be left blank, re-enter and try again.");
    } else {
      this.spinnerService.show();
      this.upsertAccountBudget(input);
    }
  }

  upsertAccountBudget(input) {
    this.budget = input;
    this.acctDetailsService.UpsertAccountBudget(this.currentAccount.AccountId, input)
        .subscribe((res) => {
        if (res.success) {
          this.showSuccess = true;
          this.successMessage = "Your budget was updated.";
        } else {
          this.showError = true;
          this.errorMessage = "An error occurred, contact an admin if the problem persists.";
        }
        () => this.spinnerService.hide();
    });
    this.showBudget = false;

  }

  validateTwoFactorCodeTemp(code) {
    this.twoFactorInput = code;
    if (code === undefined || code === null) {
      alert("Code input cannot be left blank, re-enter your code and try again.");
    } else {
      this.spinnerService.show();
      this.loginService.validateTwoFactorRequest(this.currentAccount.OrgUnitId.toString(), "1", this.meterID, code)
        .subscribe((res) => {
          if (res.success) {

            let discoModel = {
              deviceId: this.deviceId,
              email: this.customerEmail,
              sms: this.twoFactorSource === "sms" ? this.customerSMS : "",
              scheduledDate: moment.utc(this.dateselcted).toDate(),
              isOpenCommand: true
            }

            this.acctDetailsService.submitDisconnetInfo(discoModel)
              .subscribe((res) => {
                if (res.success) {
                  this.twoFactorInput = null;
                  this.showSuccess = true;
                  this.successMessage = "Your request has been successfully sent to our team to have your service connected on: " + moment(this.dateselcted).format('MMMM Do YYYY, h:mm:ss a').toString();
                  this.scheduleddate = moment(this.dateselcted).format('MMMM Do YYYY, h:mm:ss a').toString();
                  this.scheduled = true;
                  this.dateselcted = null;
                  this.cancelShutOffSelect();
                  this.showPendingCommands(this.deviceId);
                } else {
                  this.showError = true;
                  this.errorMessage = "An error has occurred, contact an administrator if the problem persists";
                }
                () => this.spinnerService.hide();
              });
          } else {
            this.twoFactorInput = null;
            this.showError = true;
            this.errorMessage = "The code you entered could not be verifed, re-enter the code we sent to your email and try again.";
          }
        })
    }
  }

  validateTwoFactorCode(code) {
    this.twoFactorInput = code;
    if (code === undefined || code === null) {
      alert("Code input cannot be left blank, re-enter your code and try again.");
    } else {
      this.spinnerService.show();
      this.loginService.validateTwoFactorRequest(this.currentAccount.OrgUnitId.toString(), "1", this.meterID, code)
        .subscribe((res) => {
          if (res.success) {

            let discoModel = {
              deviceId: this.deviceId,
              email: this.customerEmail,
              sms: this.twoFactorSource === "sms" ? this.customerSMS : "",
              scheduledDate: moment.utc(this.dateselcted).toDate(),
              isOpenCommand: false
            }

            this.acctDetailsService.submitDisconnetInfo(discoModel)
              .subscribe((res) => {
                if (res.success) {
                  this.showSuccess = true;
                  this.successMessage = "Your request has been successfully sent to our team to have your service disconnected on: " + moment(this.dateselcted).format('MMMM Do YYYY, h:mm:ss a').toString();
                  this.scheduleddate = moment(this.dateselcted).format('MMMM Do YYYY, h:mm:ss a').toString();
                  this.scheduled = true;
                  this.twoFactorInput = null;
                  this.dateselcted = null;
                  this.cancelShutOffSelect();
                  this.showPendingCommands(this.deviceId);
                } else {
                  this.showError = true;
                  this.errorMessage = "An error has occurred, contact an administrator if the problem persists";
                }
                () => this.spinnerService.hide();
              });
          } else {
            this.twoFactorInput = null;
            this.showError = true;
            this.errorMessage = "The code you entered could not be verifed, re-enter the code we sent to your email and try again.";
          }
        })
    }
  }

  sendDisconnectInfoInitial(currentAccount, datevalue) {
    if (datevalue === undefined || datevalue === null) {
      alert("You must select a disconnect date to proceed.")
    }
    else {
      this.spinnerService.show();
      datevalue = moment(datevalue).format('MMMM Do YYYY, h:mm:ss a').toString();
      this.discoDate = datevalue;

      if (this.twoFactorSource === "email") {
        this.loginService.sendTwoFactorRequest(this.currentAccount.OrgUnitId, 1, this.customerEmail, this.meterID)
          .subscribe((res) => {
            if (res.success) {
              this.showTwoFactorInput = true;
              this.showCalendar = false;
            } else {
              this.showError = true;
              this.errorMessage = "An error has occurred, contact an administrator if the problem persists";
            }
          });
      } else {
        this.loginService.sendTwoFactorRequest(this.currentAccount.OrgUnitId, 2, this.customerSMS, this.meterID)
          .subscribe((res) => {
            if (res.success) {
              this.showTwoFactorInput = true;
              this.showCalendar = false;
            } else {
              this.showError = true;
              this.errorMessage = "An error has occurred, contact an administrator if the problem persists";
            }
          });
      }
    }
  }


  getAlarmHistory(currentAccount) {
    let deviceId = this.currentAccount.DeviceId.toString();
    let orgId = this.currentAccount.OrgUnitId.toString();
    this.alarmsService.getAlarmHistory(orgId, deviceId)
      .subscribe((res) => {
        if (res.success === true) {
          this.alarms = res.modelRet;
        }
        else {
          console.log('failure');
        }
        () => this.spinnerService.hide();
      });
  }

  updateText(info) {
    return info.valueText;
  }

  getWaterUsageData(range, start, end, byUser) {
    this.spinnerService.show();
    this.loginService.getCustomerAccounts().subscribe((accts) => {
      var acctIndex = this.getActiveAcctIndex(accts, this.activeAcctID);
      let devices: AccountDeviceModel = {
        OrgUnitId: accts[acctIndex].orgUnitId,
        AccountId: accts[acctIndex].accountId,
        DeviceId: accts[acctIndex].deviceId,
        TimeRange: range,
        StartDate: start,
        EndDate: end,
        CustomDate: null,
        Lat: accts[acctIndex].lat,
        Lon: accts[acctIndex].lon,
        UtilitySupportEmail: accts[acctIndex].utilitySupportEmail,
        MeterOperationsEmail: accts[acctIndex].meterOperationsEmail,
        MeterID: accts[acctIndex].meterID,
        ServiceDate: accts[acctIndex].serviceDate,
        Budget: accts[acctIndex].budget
      }

      this.needCompare = range != '90 days' && range != '12 months';
      this.lat = devices.Lat === undefined ? 0 : devices.Lat;
      this.lon = devices.Lon === undefined ? 0 : devices.Lon;

      this.waterUsageService.getNextEstimatedBill(devices.OrgUnitId.toString(), devices.DeviceId.toString())
        .subscribe((data) => {
          if (data.success) {
            this.hasBillEstimates = true;
            this.nextBill = data.modelRet;
          } else {
            this.hasBillEstimates = false;
            this.nextBill = 0;
          }
        });


      this.waterUsageService.getCurrentBill(devices.OrgUnitId.toString(), devices.DeviceId.toString())
        .subscribe((data) => {
          if (data.success) {
            this.hasBillEstimates = true;
            this.currentBill = data.modelRet;
          } else {
            this.hasBillEstimates = false;
            this.currentBill = 0;
          }
        });

      this.waterUsageService.getComputedValue(devices.DeviceId.toString())
        .subscribe((data) => {
          if (data.success) {
            this.computedValue = data.response.computedReading;
          } else {
            this.errorMessage = 'Failed to fetch computed value. Please try again.';
          }
        });
      
      this.waterUsageService.getBillingPeriod(devices.OrgUnitId.toString(), devices.DeviceId.toString())
        .subscribe((data) => {
          if (data.success) {
            this.hasBillingRange = true;
            this.billingRange = moment(data.modelRet.startDate).format('MM/DD/YYYY') + " - " + moment(data.modelRet.endDate).format('MM/DD/YYYY');
            let mainStartDate = moment(data.modelRet.startDate).toDate();
            let mainEndDate = moment(data.modelRet.endDate).toDate();
            let currentDate = new Date();
            if (mainEndDate > currentDate) mainEndDate = currentDate;

            if (!byUser) {
              let mainDevices: AccountDeviceModel = {
                OrgUnitId: accts[acctIndex].orgUnitId,
                AccountId: accts[acctIndex].accountId,
                DeviceId: accts[acctIndex].deviceId,
                TimeRange: "CustomDate",
                StartDate: mainStartDate,
                EndDate: mainEndDate,
                CustomDate: null,
                Lat: accts[acctIndex].lat,
                Lon: accts[acctIndex].lon,
                UtilitySupportEmail: accts[acctIndex].utilitySupportEmail,
                MeterOperationsEmail: accts[acctIndex].meterOperationsEmail,
                MeterID: accts[acctIndex].meterID,
                ServiceDate: accts[acctIndex].serviceDate,
                Budget: accts[acctIndex].budget
              }
              this.waterUsageService.getRecentWaterUsageData(mainDevices)
                .subscribe((data) => {
                  if (!data.success) {
                    return;
                  }
                  let consumption = data.res.consumptionDetail;
                  this.buildOutFirstDataSource(consumption, this);
                });
            }
          } else {
            this.hasBillingRange = false;
            this.billingRange = "N/A";
            if (!byUser) {
              this.waterUsageService.getRecentWaterUsageData(devices)
                .subscribe((data) => {
                  if (!data.success) {
                    return;
                  }
                  let consumption = data.res.consumptionDetail;
                  this.buildOutFirstDataSource(consumption, this);
                });
            }
          }
        });

      this.waterUsageService.getRecentWaterUsageData(devices)
        .subscribe((data) => {
          if (!data.success) {
            return;
          }
          let time = data.res.time;
          let consumption = data.res.consumptionDetail;
          let consumptionType = data.res.consumptionType;

          this.buildOutDataSource(consumption, time, this.hasBillEstimates, consumptionType, this);        });


      //comsumption type to use in graphs and areas where gal is displayed
      this.acctDetailsService.getOrgConsumptionType(devices.OrgUnitId.toString())
        .subscribe((data) => {
          this.consumptionType = data.modelRet.type;
          if (data.modelRet.type === "gal") {
            this.consumptionType = "Gal";
            this.consumptionTypeDisplay = "Gallons";
          }
          else if (data.modelRet.type === "feet") {
            this.consumptionType = "Cubic Feet";
            this.consumptionTypeDisplay = "Cubic Feet";
          } else {
            this.consumptionType = "Litres";
            this.consumptionTypeDisplay = "Litres";
          }
        });
    });
    () => this.spinnerService.hide();
  }

  getWaterUsageCompareData(timeRange, val) {
    this.spinnerService.show();
    //used for custom range
    if (this.compareSelect === "CustomDate") {
      this.showCustomRangeMsg = true;
      if (this.compareTimeRange === "Previous 30 days") {
        let selectedMinus30 = moment(val).subtract(30, 'days').calendar();
        this.customRangeMsg = "Date range to be used for comparison: " + moment(selectedMinus30).format("L") + " thru " + moment(val).format("L");
      }
      if (this.compareTimeRange === "Previous 7 days") {
        var selectedMinus7 = moment(val).subtract(7, 'days').calendar();
        this.customRangeMsg = "Date range to be used for comparison: " + moment(selectedMinus7).format("L") + " thru " + moment(val).format("L");
      }
      if (this.compareTimeRange === "Previous 24 hours") {
        var selectedMinus24 = moment(val).subtract(1, 'days').calendar();
        this.customRangeMsg = "The previous 24 hours from the date/time you've selected will be used to compare to '24 hours'";
      }

      this.loginService.getCustomerAccounts().subscribe((accts) => {
        //get correct acct based on selected active acctid
        var acctIndex = this.getActiveAcctIndex(accts, this.activeAcctID);

        let devices: AccountDeviceModel = {
          OrgUnitId: accts[acctIndex].orgUnitId,
          AccountId: accts[acctIndex].accountId,
          DeviceId: accts[acctIndex].deviceId,
          TimeRange: this.compareTimeRange,
          CustomDate: val,
          Lat: accts[acctIndex].Lat,
          Lon: accts[acctIndex].Lon,
          UtilitySupportEmail: accts[acctIndex].utilitySupportEmail,
          MeterOperationsEmail: accts[acctIndex].meterOperationsEmail,
          MeterID: accts[acctIndex].meterID,
          ServiceDate: accts[acctIndex].serviceDate,
          StartDate: null,
          EndDate: null,
          Budget: accts[acctIndex].budget
        }
        this.waterUsageService.getWaterUsageComparisonData(devices)
          .subscribe((data) => {
            let time = data.res.time;
            let consumption = data.res.consumptionDetail;
            let comumptionPrevious = data.res.consumptionDetailToPrevious;
            this.buildOutCompareDataSource(consumption, comumptionPrevious, time, this);
            () => this.spinnerService.hide();
          });
      });
    }
    else {
      this.loginService.getCustomerAccounts().subscribe((accts) => {

        //get correct acct based on selected active acctid
        var acctIndex = this.getActiveAcctIndex(accts, this.activeAcctID);

        let devices: AccountDeviceModel = {
          OrgUnitId: accts[acctIndex].orgUnitId,
          AccountId: accts[acctIndex].accountId,
          DeviceId: accts[acctIndex].deviceId,
          TimeRange: this.compareTimeRange,
          CustomDate: null,
          Lat: accts[acctIndex].Lat,
          Lon: accts[acctIndex].Lon,
          UtilitySupportEmail: accts[acctIndex].utilitySupportEmail,
          MeterOperationsEmail: accts[acctIndex].meterOperationsEmail,
          MeterID: accts[acctIndex].meterID,
          ServiceDate: accts[acctIndex].serviceDate,
          StartDate: null,
          EndDate: null,
          Budget: accts[acctIndex].budget
        }
        this.waterUsageService.getWaterUsageComparisonData(devices)
          .subscribe((data) => {
            let time = data.res.time;
            let consumption = data.res.consumptionDetail;
            let comumptionPrevious = data.res.consumptionDetailToPrevious;
            this.buildOutCompareDataSource(consumption, comumptionPrevious, time, this);
            () => this.spinnerService.hide();
          });
      });
    }
  }

  buildOutCompareDataSource(first, second, time, context) {
    let combinedData = [];

    for (var i = 0; first.length > i; i++) {
      let _date = first[i].display;
      let _utcDate = moment.utc(_date).toDate();
      combinedData.push({
        usage: first[i].count,
        date: time === 7 || time === 30 || time === 90 ? moment(_utcDate).local().format('ll') : moment(_utcDate).local().format('lll'),
        usage2: second[i].count
      })
    }
    this.contextCompare = true;
    context.compareUsageDs = combinedData;

  }

  buildOutDataSource(raw, time, hasEst, consumptionType, context) {
    context.usageDs = [];
    this.contextCompare = false;

    this.usageTotal = 0;

    raw.forEach(function (day) {
      let _date = day.display;
      let _utcDate = moment.utc(_date).toDate();
      let _amount = context.calculateDollarAmount(day.count);
      let totalUse = context.calculateUsage(day.count);
      let _barCost = day.cost;
      let pu: PowerUsage = {
        date: time === 7 || time === 30 || time === 90 ? moment(_utcDate).local().format('ll') : time === 12 ? moment(_utcDate).local().format('MMMM YYYY') : moment(_utcDate).local().format('lll'),
        dayType: 'Weekdays',
        usage: day.count,
        amount: _amount,
        cost: _barCost,
        avgDaily: _amount,
        budget: 0,
        type: consumptionType,
        computedReading: day.computedReading
      }
      context.usageDs.push(pu);
    });

    this.items = context.usageDs;
  }

  buildOutFirstDataSource(raw, context) {
    this.mainUsageTotal = 0;
    raw.forEach(function (day) {
      let mainTotalUse = context.calculateMainUsage(day.count);
    });
  }

  getDayFromTimestamp(timestamp) {
    let date = new Date(timestamp);
    return (date.getDate() + '');
  }

  calculateDollarAmount(usage) {
    return (usage * (0.5));
  }

  calculateUsage(usage) {
    return (this.usageTotal += usage);
  }

  calculateMainUsage(usage) {
    return (this.mainUsageTotal += usage);
  }

  setShowCompare() {
    this.showCompare = true;
  }

  hideCompare() {
    this.showCompare = false;
    this.loadDatePicker = false;
    this.value = null;
    this.showCustomRangeMsg = false;
    this.getWaterUsageData(this.timeRange, null, null, true);
  }

  getUsageData(range, start, end) {
    setTimeout(() => { this.getWaterUsageData(range, start, end, true); }, 500);
  }

  customUsage(range, start, end) {
    if (range === "CustomDate" && (start === null || end === null)) {
      alert("You must select both a start date and end date value to proceed, try again.")
    } else {
      this.getUsageData(range, start, end);
    }
  }

  setTimeRange(val) {
    this.compareTimeRange = "Previous " + val;
    this.hideCompare();
    if (this.compareTimeRange === "Previous 30 days") {
      this.minDate = this.prev30DateMin;
      this.dateType = "date";
    }
    else if (this.compareTimeRange === "Previous 7 days") {
      this.minDate = this.prev7DateMin;
      this.dateType = "date";
    }
    else if (this.compareTimeRange === "Previous 24 hours") {
      this.dateType = "datetime";
      this.minDate = this.prev24DateMin;
    }

    if (val === "CustomDate") {
      this.timeRange = val;
      this.spinnerService.hide();
      this.showCustom = true;
    } else {
      this.customValueStart = null;
      this.customValueEnd = null;
      this.showCustom = false;
      this.timeRange = val;
      this.getUsageData(val, null, null);
    }

  }

  setTwoFactor(val) {
    if (val.indexOf("email") != -1) {
      this.twoFactorSource = val;
    }
    else {
      this.twoFactorSource = "cell phone";
    }
  }

  setCompareTimeRange(val) {
    if (val.indexOf("Previous") != -1) {
      this.compareSelect = val;
      this.loadDatePicker = false;
    }
    else {
      this.compareSelect = "CustomDate";
      this.loadDatePicker = true;
    }
  }

  showPendingCommands(deviceID) {
    this.acctDetailsService.getPendingCommands(deviceID.toString())
      .subscribe((res) => {
        if (res.success) {
          this.pendingCommands = res.modelRet;

          let formatDataArr = [];
          this.pendingCommands = [];

          for (var i = 0; res.modelRet.length > i; i++) {
            let _date = res.modelRet[i].schedule;
            let _utcDate = moment.utc(_date).toDate();
            formatDataArr.push({
              commandPosition: res.modelRet[i].commandPosition,
              schedule: moment(_utcDate).format('MMMM Do YYYY, h:mm:ss a'),
              commandId: res.modelRet[i].commandId
            })
          }

          this.pendingCommands = formatDataArr;

          if (this.pendingCommands.length > 0) {
            this.scheduled = true;
          } else {
            this.scheduled = false;
          }
        } else {
          this.showError = true;
          this.errorMessage = "An error has occurred, contact an administrator if the problem persists";
        }
        () => this.spinnerService.hide();
      });
  }


  ngOnInit() {
    this.orgUnitName = "";
    this.twoFactorSource = "email";
    this.showTwoFactorInput = false;
    this.showTempDiscoMsg = false;
    this.showTempDisco = false;
    this.showDiscoSelect = false;
    this.showBudget = false;
    this.showCalendar = false;
    this.showSuccess = false;
    this.showError = false;
    this.showli_one = false;
    this.showli_two = false;
    this.showli_three = false;
    this.showli_four = false;
    this.showli_five = false;
    this.showCustom = false;
    this.discoSelected = false;
    this.accepted = false;
    this.scheduled = false;

    this.spinnerService.show();
    this.loginService.getUserIsLoggedIn()
      .subscribe(isLoggedIn => {
        if (!isLoggedIn) {
          this.router.navigate(['/Login']);
        }
        else {
          this.loginService.getUserContext()
            .subscribe((ctx) => {
              //if (ctx) {
              this.activeAcctID = ctx.activeAcctId;

              //get correct acct based on selected active acctid
              var acctIDIndex = this.getActiveAcctIndex(ctx.accountsWithDevices, this.activeAcctID);

              let acctDetails = ctx.accountDetails[acctIDIndex].accountDetails;
              let accountsWithDevices = ctx.accountsWithDevices[acctIDIndex];

              this.customerSMS = acctDetails.cellPhone;
              if (this.customerSMS === null) {
                this.showTwoFactorSelect = false;
              } else {
                this.showTwoFactorSelect = true;
              }

              this.meterID = acctDetails.meterID;
              this.serviceDate = acctDetails.serviceDate;
              this.customerEmail = acctDetails.email;
              //alert(JSON.stringify(acctDetails));
              this.budget = acctDetails.budget;

              let orgUnitId = accountsWithDevices.orgUnitId;
              this.deviceId = accountsWithDevices.deviceId;

              this.currentAccount = {
                OrgUnitId: accountsWithDevices.orgUnitId,
                DeviceId: this.deviceId,
                AccountId: accountsWithDevices.accountId,
              }
              //}
            });
          this.getWaterUsageData(this.timeRange, null, null, false);
        }
        () => this.spinnerService.hide();
      });
    this.acctDetailsService.getUserInfo(this.currentAccount.OrgUnitId.toString(), this.currentAccount.AccountId.toString())
      .subscribe((res: any) => {
        if (res.success) {
          this.customerName = res.response.firstName + " " + res.response.lastName;
          this.customerInfo = {
            AccountId: res.response.accountId,
            AccountNumber: res.response.accountNumber,
            WebAccessCode: res.response.webAccessCode,
            Email: res.response.email,
            FirstName: res.response.firstName,
            LastName: res.response.lastName,
            LastFourSSN: res.response.lastFourSSN,
            OrgUnitId: res.response.orgUnitId,
            Zipcode: res.response.zipcode,
            AccountUUID: res.response.accountUUID,
            UtilityNumber: res.response.utilityNumber === null ? "" : res.response.utilityNumber,
            DeviceId: res.response.deviceId,
            Address1: res.response.address1,
            Address2: res.response.address2 === null ? "" : res.response.address2,
            City: res.response.city,
            State: res.response.state,
            CustomerContactMethods: res.response.customerContactMethods,
            Budget: res.response.budget,
            HasWaterUsageRateTableSettings: res.response.hasWaterUsageRateTableSettings
          }
        } else {
          console.log('failed to retrieve account data');
        }
      });

    this.showPendingCommands(this.deviceId);

    var myLatlng = new google.maps.LatLng(this.lat, this.lon);
    var mapProp = {
      center: myLatlng,
      zoom: 17,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    var marker = new google.maps.Marker({
      position: myLatlng,
      title: "My Water Meter"
    });
    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
    marker.setMap(this.map);

    this.getAlarmHistory(this.currentAccount);
  }

  getActiveAcctIndex(accts, activeAcctID) {
    var acctIDIndex = 0;

    //get correct acct based on selected active acctid
    for (var i = 0; i < accts.length; i++) {
      let acct = accts[i];
      if (acct.accountId == activeAcctID) {
        acctIDIndex = i;
        break;
      }
    }
    return acctIDIndex;
  }
}






// WEBPACK FOOTER //
// ./src/app/usage-container/usage-container.component.ts